export default {
  name: "FeatureCard",
  props: [
    "featureText",
    "featureIcon",
    "featureLink",
    "externalLink",
    "isExternal"
  ]
};



// WEBPACK FOOTER //
// ./src/components/landing/landingComponents/featureCard.js